import { Reducer } from 'redux'
import { PartnerProductState, PartnerProductActionTypes, PartnerProductTypes } from './types'

const initialState: PartnerProductState = {
  products: { items: [] },
  exportedSection: []
}

type ReducerOpts = Reducer<PartnerProductState, PartnerProductActionTypes>
const reducer: ReducerOpts = (state = initialState, action: PartnerProductActionTypes): PartnerProductState => {
  let index = -1
  switch (action.type) {
    case PartnerProductTypes.PARTNER_PRODUCT_GET:
      return { ...state, product: action.payload }
    case PartnerProductTypes.PARTNER_PRODUCT_GET_LIST:
      return { ...state, products: { items: action.payload, pagination: action.pagination } }
    case PartnerProductTypes.PARTNER_PRODUCT_ADD:
      return {
        ...state,
        products: { ...state.products, items: [action.payload, ...state.products.items] }
      }
    case PartnerProductTypes.PARTNER_PRODUCT_UPDATE:
      index = state.products.items.findIndex(item => item.id === action.payload.id)
      return {
        ...state,
        product: action.payload,
        products: {
          ...state.products,
          items: [
            ...state.products.items.slice(0, index),
            action.payload,
            ...state.products.items.slice(index + 1)
          ]
        }
      }
    case PartnerProductTypes.PARTNER_PRODUCT_DELETE:
      index = state.products.items.findIndex(item => item.id === action.payload)
      return {
        ...state,
        products: {
          ...state.products,
          items: [
            ...state.products.items.slice(0, index),
            ...state.products.items.slice(index + 1)
          ]
        }
      }
    case PartnerProductTypes.PARTNER_PRODUCT_SET_IS_ACTIVE:
      return {
        ...state,
        product: state.product ? { ...state.product, isActive: action.payload } : undefined
      }
    case PartnerProductTypes.PARTNER_PRODUCT_SECTION_EXPORTED:
      return {
        ...state, exportedSection: action.payload
      }
    default:
      return state
  }
}

export default reducer
